import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 112px;
`

export const Title = styled.h1`
  font-size: 26px;
`
